// src/utils/firebase/freemiumRedemptions.js
import {
  getFirestore,
  doc,
  runTransaction,
  serverTimestamp,
  getDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebase/firebaseApp";

export function monthKeyLocal(dateLike, timeZone = "Europe/London") {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    year: "numeric",
    month: "2-digit",
  }).formatToParts(d);
  const y = parts.find((p) => p.type === "year")?.value;
  const m = parts.find((p) => p.type === "month")?.value;
  return `${y}-${m}`;
}

function redemptionDocRef(db, uid, monthKey) {
  return doc(
    db,
    "breatheultra_freemium",
    uid,
    "redeemed_lung_fit_age_test",
    monthKey
  );
}

/** Return { exists:boolean, activityId:string|null, data?:any } */
export async function getRedemptionForMonth(uid, monthKey) {
  const db = getFirestore(firebaseApp);
  const ref = redemptionDocRef(db, uid, monthKey);
  const snap = await getDoc(ref);
  if (!snap.exists()) return { exists: false, activityId: null };
  const d = snap.data() || {};
  return { exists: true, activityId: d.activityId ?? null, data: d };
}

/** Atomically redeem for this month (first come, first served) */
export async function redeemFreeLungFitness({
  uid,
  monthKey,
  activityId,
  resultRef,
  activityDateMs,
}) {
  const db = getFirestore(firebaseApp);
  const ref = redemptionDocRef(db, uid, monthKey);
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    if (snap.exists()) throw new Error("already_redeemed");
    tx.set(ref, {
      month: monthKey,
      activityId: activityId ?? null,
      resultRef: resultRef ?? null,
      activityDateMs: activityDateMs ?? null,
      createdAt: serverTimestamp(),
      source: "free_monthly_spirometry",
      version: 1,
    });
  });
}
